'use client'

import cn from 'clsx'
import { Button } from '~/components/button'
import { addItem } from '../actions'
import { useCartContext } from '../cart-context'
import { useCartModal } from '../modal'
import s from './add-to-cart.module.css'

export function AddToCart({ product, variant, quantity = 1, className, icon }) {
  const { addCartItem } = useCartContext()
  const { openCart } = useCartModal()

  const buttonState = variant
    ? `ADD TO CART`
    : product?.availableForSale
      ? 'Select a size'
      : 'Coming Soon'

  async function formAction() {
    // Need to force priority
    setTimeout(() => {
      addCartItem(variant, product, quantity)
      openCart('add')
    }, 0)

    await addItem(null, {
      variantId: variant?.id,
      quantity,
    })
  }

  return (
    <form
      action={formAction}
      className={s.form}
    >
      <Button
        type="submit"
        className={cn(s.button, className)}
        aria-label="Add to cart"
        disabled={!variant}
        arrow={false}
        icon={icon}
      >
        {buttonState}
      </Button>
    </form>
  )
}
